import { InformationParagraph } from "../components/InformationParagraph";

export const buildPanelItem = (key, label, description, children) => ({
  key,
  label,
  children: description ? (
    <InformationParagraph>{description}</InformationParagraph>
  ) : (
    children
  ),
});
